import { render, staticRenderFns } from "./InformalRelationshipsDisplayAndEdit.vue?vue&type=template&id=60d94bbc&scoped=true&"
import script from "./InformalRelationshipsDisplayAndEdit.vue?vue&type=script&lang=js&"
export * from "./InformalRelationshipsDisplayAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./InformalRelationshipsDisplayAndEdit.vue?vue&type=style&index=0&id=60d94bbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d94bbc",
  null
  
)

export default component.exports